import {Component, NgModule, ViewContainerRef} from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
  selector: 'dialog2',
  styles: [require('./dialog2.component.less')],
  template: require('./dialog2.component.html'),
  preserveWhitespaces: true
})
export class Dialog2 {
  constructor(public dialogRef: MatDialogRef<any>) { }
}